export enum StorageValues {
  HiddenMuteModalEvents = 'hiddenMuteModalEvents',
  DismissMessages = 'dismissMessages',
  Assistant = 'assistant',
  ExtraLaunchArgs = 'extraLaunchArgs',
}

export enum StorageTypes {
  Local = 'local',
  Session = 'session',
}
